import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import UserConnectionSkeleton from "components/ui/UserConnectionSkeleton";
import './MatchingListSkeleton.css';

/**
 * Mirrors the structure of MatchingList.tsx:
 *  - Header row: "User Connections" h4 · Searchbar
 *  - MatchingCardData area (UserConnection cards)
 */
const MatchingListSkeleton: React.FC = () => (
  <div>
    {/* Header row — d-flex justify-content-between align-items-center flex-wrap */}
    <div className="d-flex justify-content-between align-items-center position-relative flex-wrap mb-3">
      {/* Title */}
      <Skeleton width={180} height={28} borderRadius={6} />

      {/* Right: searchbar pill only — Filter button was removed */}
      <div className="d-flex align-items-center gap-3">
        <Skeleton width={220} height={42} borderRadius={50} />
      </div>
    </div>

    {/* MatchingCardData — UserConnection cards */}
    <UserConnectionSkeleton cards={5} />
  </div>
);

export default MatchingListSkeleton;
